import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-acb298f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row lg:justify-between lg:items-center" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-left text-primary mb-4" }, " Detalle de pagos aplicados ", -1))
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs text-gris80 font-semibold" }, " Filtre rango de mes y año a consultar ", -1))
const _hoisted_7 = { class: "flex flex-col gap-2 lg:flex-row lg:items-end" }
const _hoisted_8 = { class: "text-left" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gris80 text-xs font-semibold text-left" }, "Desde mes", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Seleccione", -1))
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "text-left" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gris80 text-xs font-semibold" }, "Del año", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Seleccione", -1))
const _hoisted_15 = ["value"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 0,
  class: "preloader-container"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "preloader" }, null, -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "w-full overflow-x-auto" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-left text-xs text-gris80 font-semibold mt-3" }, " Si evidencia que faltan pagos por aplicar, por favor háganos llegar su soporte de pago por la opción “Canales de atención” ", -1))
const _hoisted_22 = {
  key: 0,
  class: "flex flex-col py-4"
}
const _hoisted_23 = { class: "grid gap-y-2 grid-cols-1 text-left" }
const _hoisted_24 = /*#__PURE__*/_createStaticVNode("<div class=\"hidden bg-lightSurface-50 rounded px-2 py-1 lg:visible lg:grid lg:gap-2 lg:text-center lg:items-center lg:grid-cols-6\" data-v-acb298f0><h2 class=\"text-xs text-gris80 font-semibold\" data-v-acb298f0> Fecha de Transacción </h2><h2 class=\"text-xs text-gris80 font-semibold\" data-v-acb298f0> Valores de Transacción </h2><h2 class=\"text-xs text-gris80 font-semibold\" data-v-acb298f0>Valor Aplicado</h2><h2 class=\"text-xs text-gris80 font-semibold\" data-v-acb298f0>Número de Cuota</h2><h2 class=\"text-xs text-gris80 font-semibold\" data-v-acb298f0> Número de Financiación </h2><h2 class=\"text-xs text-gris80 font-semibold\" data-v-acb298f0>Saldo cuota</h2></div>", 1)
const _hoisted_25 = { class: "flex flex-row justify-between px-2 py-1 lg:flex-col" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xs text-gris80 font-semibold lg:hidden" }, " Fecha de Transacción ", -1))
const _hoisted_27 = { class: "text-xs text-gray-500" }
const _hoisted_28 = { class: "flex flex-row justify-between px-2 py-1 lg:flex-col" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xs text-gris80 font-semibold lg:hidden" }, " Valores de Transacción ", -1))
const _hoisted_30 = { class: "text-xs text-gray-500" }
const _hoisted_31 = { class: "flex flex-row justify-between px-2 py-1 lg:flex-col" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xs text-gris80 font-semibold lg:hidden" }, " Valor Aplicado ", -1))
const _hoisted_33 = { class: "text-xs text-gray-500" }
const _hoisted_34 = { class: "flex flex-row justify-between px-2 py-1 lg:flex-col" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xs text-gris80 font-semibold lg:hidden" }, " Número de Cuota ", -1))
const _hoisted_36 = { class: "text-xs text-gray-500" }
const _hoisted_37 = { class: "flex flex-row justify-between px-2 py-1 lg:flex-col" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xs text-gris80 font-semibold lg:hidden" }, " Número de Financiación ", -1))
const _hoisted_39 = { class: "text-xs text-gray-500" }
const _hoisted_40 = { class: "flex flex-row justify-between p-2 py-1 lg:flex-col" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xs text-gris80 font-semibold lg:hidden" }, " Saldo cuota ", -1))
const _hoisted_42 = { class: "text-xs text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("select", {
                class: "border-gray-400 rounded text-xs",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.monthField) = $event))
              }, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMonths(), (value, key) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: key,
                    key: key
                  }, _toDisplayString(value), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.monthField]
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _withDirectives(_createElementVNode("select", {
                class: "border-gray-400 rounded text-xs",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.yearField) = $event))
              }, [
                _hoisted_14,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getYears(), (year) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: year,
                    key: year
                  }, _toDisplayString(year), 9, _hoisted_15))
                }), 128))
              ], 512), [
                [_vModelSelect, _ctx.yearField]
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "w-full h-10 px-4 py-2 text-base text-white rounded-lg bg-secondary border md:w-auto md:h-9 md:text-xs md:mr-1 mb-3 md:mb-0",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.getFilter()), ["prevent"]))
              }, " Filtrar "),
              _createElementVNode("button", {
                type: "button",
                class: "w-full h-10 px-4 py-2 text-base text-white rounded-lg bg-success border md:w-auto md:h-9 md:text-xs disabled:opacity-70",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.downloadDocument()), ["prevent"])),
                disabled: _ctx.detailItems.length === 0
              }, " Descargar ", 8, _hoisted_16)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      (!_ctx.showLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _hoisted_24,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailItems, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "bg-white shadow-md rounded m-1 lg:grid lg:gap-2 lg:text-center lg:shadow-none lg:grid-cols-6",
                  key: item.codAutorizacion
                }, [
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$filters.formatDate(item.payment_date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$filters.currency(item.value_paid)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$filters.currency(item.value_paid_fee)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, _toDisplayString(item.fee_number), 1)
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("div", _hoisted_39, _toDisplayString(item.register_id), 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$filters.currency(item.balance_fee)), 1)
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}